import ItemCardSmallPreview from './itemCardSmallPreview'

export default ItemCardSmallPreview
